// extracted by mini-css-extract-plugin
export default {"list":"list--pyhaG small--gEBo0 form-control_size_small","listBtn":"listBtn--w0X_I"};